import {reactive} from "vue"

export const windowWatcher = reactive({
    width: window.innerWidth
})
addEventListener("resize", (event) => {
    windowWatcher.width = window.innerWidth
});
